import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import CustomButton, { BUTTON_TYPES } from '@/components/ui/button'
import { MoneyGoldIcon, MoneySilverIcon, PopoverIcon } from '@icons'
import { memo, useMemo } from 'react'
import { binder, path } from '@constants/router'
import { LOCUS_TYPES } from '@constants/definition'
import styles from './styles.module.css'

const InfoCardWithLocuses = ({ gold, silver }) => {
  const { t } = useTranslation(['common', 'draw'])

  const data = useMemo(
    () => [
      {
        label: t('locus::gold'),
        value: gold || 0,
        href: path.CABINET_PROMOCODE,
        linkText: t('draw::cards::enterPromocode'),
        icon: MoneyGoldIcon,
        isPopover: false,
      },
      {
        label: t('locus::silver'),
        value: silver || 0,
        href: path.DRAW_APARTMENTS_CONVERTATION,
        linkText: t('draw::cards::convert'),
        icon: MoneySilverIcon,
        isPopover: true,
      },
    ],
    [t, gold, silver]
  )

  return (
    <div className={styles.cardContainer}>
      <div className={styles.cardRow}>
        {data.map(({ label, value, href, linkText, icon: Icon, isPopover }) => (
          <div key={label} className={styles.cardColumn}>
            <div className={styles.cardLabel}>{label}</div>
            <div className={styles.cardCountRow}>
              <div className={styles.cardIcon}>
                <Icon />
              </div>
              <div className={styles.cardCount}>{value}</div>
            </div>
            <Link href={href}>
              <a rel="nofollow" className={styles.linkText}>
                {linkText}
                {isPopover && (
                  <span>
                    <PopoverIcon />
                  </span>
                )}
              </a>
            </Link>
          </div>
        ))}
      </div>
      <Link href={binder(path.PUBLICATION_LOCUS, { locus: LOCUS_TYPES.GOLD })}>
        <a rel="nofollow" className={styles.cardButtonWrapper}>
          <CustomButton text={t('draw::cards::topUp')} type={BUTTON_TYPES.BLUE} />
        </a>
      </Link>
    </div>
  )
}

export default memo(InfoCardWithLocuses)
